export { MorphemeTranscription } from "#morpheme-transcription";
